import { useEffect, useState } from "react";

const useStatus = () => {
  const location = window.location.hostname;
  const [status, setStatus] = useState("");
  const [devActive, setDevActive] = useState(false);
  const [stageActive, setStageActive] = useState(false);
  useEffect(() => {
    if (location?.includes("development")) {
      setStatus("Development");
      setDevActive(true);
    } else if (location?.includes("staging")) {
      setStatus("Staging");
      setStageActive(true);
    } else if (location?.includes("localhost")) {
      setStatus("Localhost");
      setDevActive(true);
    } else {
      setStatus("");
      setStageActive(false);
      setDevActive(false);
    }
  }, []);
  return { status, devActive, stageActive };
};

export default useStatus;
